import React from 'react';
import {Helmet} from "react-helmet";
import Layout from '../components/Layout';
import AudiForm from '../components/AudiForm';
import Disclaimer from '../components/Disclaimer';
import ReturnToButton from '../components/ReturnToButton';
import queryString from 'query-string';
import MakeModule from '../components/MakeModule';
import Loader from '../components/Loader';
import { formatMobile } from '../functions/textFormatting';
import { gtmPageview } from '../functions/gtm';
import { prefCentreService } from '../functions/apiRequestHelper';
import {
    UI_AUDI,
    PATH_ADE_RYI,
    PATH_THANKS,
    FIELD_TEXT,
    FIELD_CHECKBOX
} from '../constants';

const formCopy = {
    "f1": {
        hero: (<div className="audi-forms__hero-v2" style={{background: "#000"}}>
            <img src={`${process.env.PUBLIC_PATH}img/f1speed.jpg`} alt="" style={{opacity: "30%"}} />
            <div className="audi-forms__page py-3 d-flex flex-column justify-content-between text-uppercase">
                <div className="aui-headline-5" style={{color: "#fff"}}>Register your interest</div>
                <div className="aui-headline-1" style={{color: "#fff"}}>Don't miss a moment.</div>
            </div>
        </div>),
        main: (<>
            <h1 className="aui-headline-3 mb-4">Audi Trackside Suite 2027</h1>
            <p className="mb-3">The Audi Trackside Suite will return for the FORMULA 1 QATAR AIRWAYS AUSTRALIAN GRAND PRIX 2027, following a highly anticipated debut season in Melbourne.</p>
            <p>The Audi Trackside Suite offers the ultimate F1® experience with a premium trackside view to experience Formula 1® from lights out to the final lap.</p>
        </>),
        thanks: (<>
            <h1 className="aui-headline-3 mb-4">Thank you for registering your interest</h1>
            <p className="mb-5">You'll be the first to know about the Audi 2027 FORMULA 1&reg; experience</p>
        </>),
       extraFields: [
            {
                field: FIELD_CHECKBOX,
                name: "optIn",
                label: <>I would like to be contacted by Audi Australia about Formula 1&reg;.*</>
            }
       ],
       hiddenFields: {eventName: "Formula 1"},
       schema: {optIn: {truthy: {message: "This field is required"}}}
    },
    "default": {
        hero: (<div className="audi-forms__hero">
                <img src={`${process.env.PUBLIC_PATH}img/audi-driving-experience.jpg`} alt="" />
            </div>),
        main: (<>
            <h1 className="aui-headline-3 mb-4">Register your interest.</h1>
            <p className="mb-3">
                Combining Audi{`'`}s award-winning performance cars with a celebrated team of internationally-trained instructors,
                the Audi driving experience is acknowledged as one of the leading performance driving programs in Australia and around the globe.
            </p>
            <p>Register your interest to stay informed about upcoming events.</p>
        </>),
        thanks: (<>
            <h1 className="aui-headline-3 mb-4">Thanks for your interest in Audi driving experience.</h1>
            <p className="mb-5">We'll be sure to send you updates.</p>
        </>),
        extraFields: [
            {
                module: MakeModule,
                title: "What are you currently driving?"
            }
        ],
        hiddenFields: {optOut: false}
    }
};

class ADERegisterInterest extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            isFetchingUser: true,
            submitted: false,
            submittedData: {},
            isIframed: false
        }
    }

    componentDidMount() {
        const query = queryString.parse(this.props.location.search);
        if (query.sfid) {
            prefCentreService.get(query.sfid).then((result) => {
                this.setState({user: result, isFetchingUser: false});
            }).catch((error) => {
                console.error('user error', error);
                this.setState({isFetchingUser: false});
            });
        } else {
            this.setState({isFetchingUser: false});
        }
        gtmPageview(PATH_ADE_RYI);
    }

    onSubmit = (values) => {
        const {match} = this.props;
        this.setState({submitted: true, submittedData: values});
        // this.props.history.push(`${PATH_ADE_RYI}${PATH_THANKS}`);
        let path = `${PATH_ADE_RYI}${PATH_THANKS}`;
        if (match.params.program && typeof formCopy[match.params.program] !== "undefined") {
            path = `${PATH_ADE_RYI}/${match.params.program}${PATH_THANKS}`;
        }
        gtmPageview(path);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const {match} = this.props;
        const {submitted, user, isFetchingUser} = this.state;
        let fc = formCopy["default"];
        if (match.params.program && typeof formCopy[match.params.program] !== "undefined") {
            fc = formCopy[match.params.program];
        }
        let prefillMobile = "";
        if (user && user.mobile && user.mobile.indexOf('04') === 0) {
            prefillMobile = user.mobile.replace(/\s/g, '');
        }
        let fields = [
            [
                {
                    field: FIELD_TEXT,
                    name: "firstName",
                    label: "First name*",
                    value: user.firstName || "",
                    colClass: "col-12 col-tiny"
                },
                {
                    field: FIELD_TEXT,
                    name: "lastName",
                    label: "Last name*",
                    value: user.lastName || "",
                    colClass: "col-12 col-tiny"
                }
            ],
            {
                field: FIELD_TEXT,
                name: "emailAddress",
                label: "Email*",
                value: user.email || ""
            },
            {
                field: FIELD_TEXT,
                name: "mobilePhone",
                label: "Mobile phone*",
                formatValue: formatMobile,
                value: prefillMobile,
                colClass: "col-12 col-small-6"
            },
            {
                field: FIELD_TEXT,
                name: "postCode",
                label: "Postcode*",
                colClass: "col-12 col-small-6"
            }
        ];
        if(fc.extraFields?.length) {
            fields.push(...fc.extraFields);
        }
        return (
            <Layout ui={query.ui || UI_AUDI} theme={query.theme} embedded={query.embedded} onDetectIframe={(v) => { this.setState({isIframed: v}); }}>
                <Helmet>
                    <title>Register your interest in Audi Driving Experience | Audi Australia</title>
                </Helmet>

                {!this.state.isIframed && fc.hero}

                <main className="audi-forms__page">

                    {submitted && <div className="py-5">
                        {fc.thanks}
                        <ReturnToButton query={query} theme={query.theme} />
                    </div>}

                    {!submitted && <div className="py-5">
                        {fc.main}
                    </div>}

                    {isFetchingUser && <Loader><p><b>One moment, we are retrieving your details...</b></p></Loader>}

                    {!submitted && !isFetchingUser && <div className="pb-5">
                        <AudiForm formName="registerExperienceInterest"
                            fields={fields}
                            hiddenFields={fc.hiddenFields}
                            schema={typeof fc.schema !== "undefined" ? fc.schema : null}
                            onSubmitSuccess={this.onSubmit}
                            style={{maxWidth: "840px"}}
                            theme={query.theme}
                        />
                        <Disclaimer theme={query.theme} />
                    </div>}

                </main>
            </Layout>
        );
    }

}

export default ADERegisterInterest;
